import type * as SchemaTypes from '../types';

import type { TranslatedStringDataFragment } from './TranslatedStringData';
import type { UploadFileWithPreviewFormDataFragment } from './UploadFileWithPreviewFormData';
import { gql } from '@apollo/client';
import { TranslatedStringDataFragmentDoc } from './TranslatedStringData';
import { UploadFileWithPreviewFormDataFragmentDoc } from './UploadFileWithPreviewFormData';
export type DealerSocialMediaFragmentFragment = (
  { __typename: 'DealerSocialMedia' }
  & Pick<SchemaTypes.DealerSocialMedia, 'id' | 'content'>
  & { title: (
    { __typename: 'TranslatedString' }
    & TranslatedStringDataFragment
  ), icon?: SchemaTypes.Maybe<(
    { __typename: 'UploadedFileWithPreview' }
    & UploadFileWithPreviewFormDataFragment
  )> }
);

export const DealerSocialMediaFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment DealerSocialMediaFragment on DealerSocialMedia {
  id
  title {
    ...TranslatedStringData
  }
  content
  icon {
    ...UploadFileWithPreviewFormData
  }
}
    `;